import angular from 'angular';

import IncomeExpenseChartComponent from './income-expense-chart.cmpt';

export default angular
    .module('application.scene.authorized.scene.dashboard.component.income-expense-chart', [])
    .component(IncomeExpenseChartComponent.selector, IncomeExpenseChartComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/income-expense-chart/index.js